import styled from 'styled-components';
import { getColor } from 'utils';
import constants from 'constants/index';
const light = constants.THEME.LIGHT;

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const Section = styled('div')`
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  height: ${props => props.height || '100%'};
`;

export const ImageView = styled('div')`
  position: relative;
  width: ${props => props.w || '50px'};
  height: ${props => props.h || '50px'};
  flex-shrink: 0;
  background-image: ${props => `url(${props.image})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export const Title = styled('div')`
  color: ${props => getColor(props, 'onPrimary')};
  font-family: 'Poppins-Bold';
  font-size: ${props => props.size || '48px'};
  font-weight: ${props => props.weight || 800};
  line-height: ${props => props.lineHeight || 'normal'};
  text-align: center;
`;

export const Text = styled('div')`
  color: ${props => getColor(props, 'onPrimary')};
  font-family: ${props => props.font || 'Poppins-Medium'};
  font-size: ${props => props.size || '16px'};
  text-align:  ${props => props.align || 'center'};
  font-weight:${props => props.weight || 400};
  max-width: ${props => props.maxWidth || 'none'};
  margin:${props => props.margin || '0'};
`;

export const Box = styled('div')`
  width: ${props => props.w || '50px'};
  height: ${props => props.h || '50px'};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background-color: transparent;
  justify-content: ${props => props.content || 'center'};
`;

export const BoxesContainer = styled('div')`
  display: flex; 
  justify-content: center;
  gap: ${props => props.space || '40px'};
  width: 100%;
  height: ${props => props.h || 'auto'};
  margin: 0 auto;
`;

export const Containers = styled('div')`
  display: flex; 
  align-items: center;
  gap: ${props => props.space || '40px'};
  width: 100%;
  margin: 0 auto;
`;

export const Icon = styled('div')`
  position: relative;
  flex-shrink: 0;
  width: ${props => props.w || '50px'};
  height: ${props => props.h || '50px'};
  background-image: ${props => `url(${props.image})`};
  filter: invert(${props => (props.$selectedTheme === light) ? 0 : 1});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export const BoxHeader = styled('div')`
  font-family: Poppins-Regular;
  display: inline-flex;
  flex-direction: row; 
  align-items: center;
  background-color: transparent;
  border: none;
  transition: background-color 0.3s;
  color: ${props => getColor(props, 'onPrimary')};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  justify-content: flex-start;
  padding-left: 25px;
`;

export const CapabilitiesParagraph = styled('div')`
  color: ${props => getColor(props, 'onPrimary')};
  font-family: Poppins-Regular;
  font-size: 24px;
  font-style: normal;
  font-weight: ${props => props.fontWeight || 400};
  line-height: normal;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 800px;
  height: 800px;
`;

export const OverlapImage = styled.div`
  position: absolute;
  width: ${props => props.w || '100%'};
  height: ${props => props.h || '100%'};
  top: ${props => props.top || '0'};
  left: ${props => props.left || '0'};
  right: ${props => props.right || 'auto'};
  bottom: ${props => props.bottom || 'auto'};
  object-fit: ${props => props.objectFit || 'cover'};
  background-image: ${props => `url(${props.image})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;